<template>
  <div class="action-config-item">
    <div class="mb-4">
      <label for="action-name" class="block text-sm font-semibold text-gray-700">Action Name</label>
      <el-input
        v-model="localStep.label"
        id="action-name"
        placeholder="Enter Action Name"
        clearable
        class="w-full rounded-md"
      />
    </div>
    <div>
      <el-button @click="openFolderConfigureModal()" icon="el-icon-s-tools">Configure</el-button>
    </div>
    <dialog-component
      :visible="mapFolderConfigureModal"
      :title="'Folder mapping'"
      @before-close="resetFolderConfigureTemplate"
      :containerWidth="'60%'"
      :isShowFooter="false"
    >
      <div v-if="deleteFolder" class="popUp-content" :style="'min-height: 100px;'">
        <div class="delete-files-container">
          <span>Delete folder condition</span>
        </div>
        <div>
          <div class="d-flex mt-1" style="gap: 5px">
            <el-select placeholder="From" v-model="deleteActionEntityFoldersList.type">
              <el-option
                value="CURRENT_DATA"
                label="Current data"
                v-if="checkSelfTriggerAction && !trigger.is_global_action"
              ></el-option>
              <el-option
                v-if="trigger.is_global_action"
                value="ROOT"
                :label="currentEntity.name + ' root'"
              ></el-option>
            </el-select>
            <el-select
              placeholder="Select root folder"
              v-if="actionEntityFoldersListType == 'ROOT'"
              v-model="deleteActionEntityFoldersList.folder"
              clearable
              class="ml-1"
            >
              <el-option
                v-for="folder in entityRootFolders"
                :key="folder._id"
                :value="folder._id"
                :label="folder.name"
              ></el-option>
            </el-select>
            <el-select
              placeholder="Query on"
              v-model="deleteActionEntityFoldersList.query_on"
              :disabled="!deleteActionEntityFoldersList.type ? true : false"
              class="ml-1"
            >
              <!-- <el-option value="UPDATED" label="Last updated"></el-option> -->
              <el-option value="CREATED" label="Created"></el-option>
            </el-select>
            <el-select
              placeholder="Query type"
              v-model="deleteActionEntityFoldersList.query_type"
              :disabled="!deleteActionEntityFoldersList.query_on ? true : false"
              class="ml-1"
            >
              <el-option value="YEAR" label="Year"></el-option>
              <el-option value="MONTH" label="Month"></el-option>
              <el-option value="DAYS" label="Days"></el-option>
            </el-select>
            <el-input-number
              placeholder="Query duration"
              v-model="deleteActionEntityFoldersList.query_duration"
              :min="1"
              :disabled="!deleteActionEntityFoldersList.query_type ? true : false"
              class="ml-1"
            ></el-input-number>
          </div>
        </div>
      </div>
      <div class="popUp-content" v-else>
        <el-select placeholder="Create on" v-model="actionEntityFoldersListType">
          <el-option
            value="CURRENT_DATA"
            label="Current data"
            v-if="checkSelfTriggerAction && !trigger.is_global_action"
          ></el-option>
          <el-option
            value="ROOT"
            :label="currentEntity.name + ' root'"
            v-if="trigger.is_global_action"
          ></el-option>
        </el-select>
        <el-select
          placeholder="Select root folder"
          v-if="actionEntityFoldersListType == 'ROOT'"
          v-model="actionEntityFoldersListFolder"
          clearable
          class="ml-1"
        >
          <el-option
            v-for="folder in entityRootFolders"
            :key="folder._id"
            :value="folder._id"
            :label="folder.name"
          ></el-option>
        </el-select>
        <div v-if="actionEntityFoldersList && actionEntityFoldersList.length">
          <el-scrollbar wrap-style="max-height: 600px;">
            <div class="files-container">
              <div v-for="(file, i) in actionEntityFoldersList" :key="file._id" class="single-file">
                <div class="file-header" :style="'color: #409EFF;'">
                  <i class="el-icon-folder" v-if="file.type == 'FOLDER'"></i>
                  <i
                    class="el-icon-picture-outline"
                    v-else-if="file.file_format && isImage(file.file_format)"
                  ></i>
                  <i class="el-icon-tickets" v-else></i>
                </div>
                <div class="file-title">
                  <span v-if="file.name">
                    {{ file.name | truncate(14, '...') }}
                  </span>
                  <span v-else-if="file.name_mapped_with">
                    {{ file.name_mapped_with }}
                  </span>
                  <el-dropdown class="action-button">
                    <i class="el-icon-more" style="transform: rotate(90deg)"></i>
                    <el-dropdown-menu slot="dropdown">
                      <a @click="onDelete(i)">
                        <el-dropdown-item>Delete</el-dropdown-item>
                      </a>
                      <a @click="openSettingsModal(file, i)">
                        <el-dropdown-item>
                          <i class="el-icon-setting"></i>
                          Settings
                        </el-dropdown-item>
                      </a>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
              <div class="single-file" @click="openNew">
                <div class="file-header" :style="'color: #409EFF;'">
                  <i class="el-icon-plus"></i>
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div>
        <div class="no-files" v-else>
          <el-empty description="No files">
            <el-link type="primary" :underline="false" @click="openNew">Create new</el-link>
          </el-empty>
        </div>
      </div>
      <!-- Footer Actions -->
      <div class="automation-footer-actions mt-4 flex justify-end gap-2">
        <el-button @click="cancelChanges">Cancel</el-button>
        <el-button type="primary" @click="saveChanges">Save</el-button>
      </div>
    </dialog-component>
    <dialog-component
      :visible="openNewFileModal"
      :title="'Add new file or folder'"
      @before-close="resetModal"
      :containerWidth="'50%'"
    >
      <div class="popUp-content">
        <div>
          Type
          <el-select placeholder="Select type" v-model="newFile.type" style="width: 100%">
            <el-option value="FOLDER" label="Folder"></el-option>
            <el-option
              value="UPLOAD_FOLDER"
              label="Upload Folder"
              v-if="actionEntityFoldersListType !== 'CURRENT_DATA'"
            ></el-option>
          </el-select>
        </div>
        <div class="mt-1">
          Name
          <el-input
            v-model="newFile.name"
            placeholder="Enter name"
            :disabled="newFile.name_mapped_with ? true : false"
            clearable
          ></el-input>
          OR
          <el-select
            placeholder="Create with"
            v-model="newFile.name_mapped_with"
            style="width: 100%"
            clearable
            :disabled="newFile.name ? true : false"
          >
            <el-option value="CURRENT_DATE" label="Current date"></el-option>
            <el-option value="CURRENT_DAY" label="Current day"></el-option>
            <el-option value="CURRENT_MONTH" label="Current month"></el-option>
            <el-option value="CURRENT_YEAR" label="Current year"></el-option>
          </el-select>
        </div>
        <div v-if="newFile.type == 'FILE'" class="mt-1">
          Upload file
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :auto-upload="false"
            :on-change="upload"
            multiple
          >
            <div class="upload-attchment-box">
              <img src="@/assets/img/fields/attachment-filling.svg" alt="Upload File" height="20" />
              <h4 class="ml-1">Upload a file</h4>
            </div>
          </el-upload>
          <div class="mt-1" v-if="newFile && newFile.files && newFile.files.length">
            <div v-for="(file, i) in newFile.files" :key="i" class="d-flex">
              <i class="el-icon-document" style="margin-top: 5px"></i>
              <span>{{ file.name }}</span>
              <el-link
                icon="el-icon-close"
                type="primary"
                :underline="false"
                style="margin-left: 5px"
              ></el-link>
              <!-- @click="removeFile(i)" -->
              <!-- removed removeFile method as it is not there even in old code  -->
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetModal">Close</el-button>
        <el-button type="primary" :disabled="checkDisabled" @click="saveFolder">Save</el-button>
      </span>
    </dialog-component>
    <dialog-component
      :visible="settingsModal"
      :title="'Settings'"
      @before-close="resetEditModal"
      :containerMinWidth="'50%'"
      :containerMaxWidth="'50%'"
      :containerMaxHeight="'70%'"
      :containerMinHeight="'30%'"
    >
      <div class="dialog-context m-tb-2 m-lr-2" v-if="editForm && editForm.permission_settings">
        <el-checkbox v-model="editForm.permission_settings.lock_folder">Lock folder?</el-checkbox>
        <div
          class="d-flex mt-1 mb-1 align-center flex-wrap gap-1"
          v-if="editForm.permission_settings.lock_folder"
        >
          <span class="mr-1">Lock folder for</span>
          <el-select
            v-model="editForm.permission_settings.application_users"
            clearable
            placeholder="Select user"
            multiple
            size="mini"
            style="width: 120px"
            collapse-tags
          >
            <el-option
              v-for="(entity, i) in (allEntities || []).filter(
                (e) => e.entity_type == 'BUSINESS' || e.entity_type == 'INDIVIDUAL'
              )"
              :key="entity + 'entity' + i"
              :value="entity._id"
              :label="entity.name"
            ></el-option>
          </el-select>
          <span class="ml-2 mr-1">after</span>
          <el-input-number
            :min="0"
            type="number"
            size="mini"
            v-model="editForm.permission_settings.value"
            style="width: 80px"
          ></el-input-number>
          <el-select
            v-model="editForm.permission_settings.type"
            placeholder="Type"
            size="mini"
            style="width: 100px"
          >
            <el-option value="DAY" label="Day"></el-option>
            <el-option value="MONTH" label="Months"></el-option>
            <el-option value="YEAR" label="Years"></el-option>
          </el-select>
          <span class="ml-1">from created date</span>
          <el-tooltip
            class="ml-1"
            effect="dark"
            :content="
              'After that selected user not able to do upload files into current folder. Taking 0 will be current' +
              editForm.permission_settings.type
            "
            placement="bottom"
          >
            <i class="el-icon-info"></i>
          </el-tooltip>
        </div>
      </div>
      <div>
        Who can open:
        <el-select
          v-model="editForm.upload_filter"
          placeholder="Anyone"
          size="mini"
          style="width: 180px"
          clearable
        >
          <el-option
            v-for="flt in allEntityFilters[currentEntity._id]"
            :key="flt._id"
            :label="flt.filter_name"
            :value="flt._id"
          ></el-option>
        </el-select>
      </div>
      <div class="popUp-content" v-if="editForm && editForm.approval_settings">
        <el-checkbox v-model="editForm.approval_settings.approval_folder">
          Approval folder?
        </el-checkbox>
        <div
          class="mt-1 mb-1"
          style="display: flex; flex-direction: column"
          v-if="editForm.approval_settings.approval_folder"
        >
          <h5 class="mt-1">Notify approver settings</h5>
          <span>Requesting users</span>
          <el-select
            v-model="editForm.approval_settings.requesting_users"
            clearable
            placeholder="Requesting user"
            multiple
            size="mini"
            collapse-tags
          >
            <el-option
              v-for="(entity, i) in (allEntities || []).filter(
                (e) => e.entity_type == 'BUSINESS' || e.entity_type == 'INDIVIDUAL'
              )"
              :key="entity + 'entity' + i"
              :value="entity._id"
              :label="entity.name"
            ></el-option>
          </el-select>

          <span>Approver user type</span>
          <el-select
            v-model="editForm.approval_settings.approver_type"
            placeholder="Approver type"
            size="mini"
          >
            <el-option value="APPLICATION_USER" label="Application user"></el-option>
            <el-option value="COMPANY_USER" label="Company user"></el-option>
            <el-option value="BASED_ON_DATA" label="Based on data"></el-option>
          </el-select>
          <span v-if="editForm.approval_settings.approver_type !== 'BASED_ON_DATA'">
            Approver type
          </span>
          <el-select
            v-model="editForm.approval_settings.approver_user_ids"
            clearable
            placeholder="Approver users"
            multiple
            size="mini"
            collapse-tags
            v-if="editForm.approval_settings.approver_type == 'APPLICATION_USER'"
          >
            <el-option
              v-for="(entity, i) in (allEntities || []).filter(
                (e) => e.entity_type == 'BUSINESS' || e.entity_type == 'INDIVIDUAL'
              )"
              :key="entity + 'entity' + i"
              :value="entity._id"
              :label="entity.name"
            ></el-option>
          </el-select>
          <el-select
            v-model="editForm.approval_settings.approver_user_ids"
            clearable
            placeholder="Approver users"
            multiple
            size="mini"
            collapse-tags
            v-if="editForm.approval_settings.approver_type == 'COMPANY_USER'"
          >
            <el-option
              v-for="item in getUserTypeList"
              :key="item._id"
              :label="getLabel(item)"
              :value="item._id"
            ></el-option>
          </el-select>
          <span v-if="editForm.approval_settings.approver_type !== 'BASED_ON_DATA'">
            Approver users
          </span>
          <el-select
            v-model="editForm.approval_settings.approver_users"
            clearable
            placeholder="Approver users"
            multiple
            size="mini"
            collapse-tags
            v-if="editForm.approval_settings.approver_type !== 'BASED_ON_DATA'"
          >
            <el-option
              v-for="(user, i) in getUserEmailList(
                editForm.approval_settings.approver_user_ids,
                editForm.approval_settings.approver_type
              )"
              :key="user + 'user' + i"
              :value="user.email"
              :label="user.email"
            ></el-option>
          </el-select>
          <span v-if="editForm.approval_settings.approver_type == 'BASED_ON_DATA'">
            Approver user fields
          </span>
          <el-select
            v-model="editForm.approval_settings.approver_fields"
            clearable
            placeholder="Approver user fields"
            multiple
            size="mini"
            collapse-tags
            v-if="editForm.approval_settings.approver_type == 'BASED_ON_DATA'"
          >
            <el-option
              v-for="(field, i) in getUserEntities(
                getFieldsByType(['ENTITY'], allFieldsWithDataTable)
              )"
              :key="field + i"
              :value="field.key"
              :label="field.label"
            ></el-option>
          </el-select>
          <!--Approval mail template settings-->
          <h5 class="mt-1">Approver Email template settings</h5>
          <div style="display: flex">
            <div style="width: 49%; margin-right: 2%">
              <span>Subject</span>
              <el-input
                v-model="editForm.approval_settings.mail_template_data.subject"
                placeholder="Enter subject"
              ></el-input>
            </div>
            <div style="width: 49%">
              <span>Select Field to copy</span>
              <el-select
                style="width: 100%"
                v-model="copyField"
                placeholder="Select Field to copy"
                filterable
                class="email-field"
                @change="copyURL"
              >
                <el-option
                  v-for="(item, index) of getSupportedSubjectFields()"
                  v-bind:key="index"
                  :label="item.label"
                  :value="item.label"
                >
                  {{ item.label }} ({{ item.input_type }})
                  <a
                    v-if="item.isSubjectSupported"
                    @click.stop="pushToSubject(item.label, 'approval_settings')"
                  >
                    <i class="el-icon-right" style="color: #409eff"></i>
                  </a>
                </el-option>
              </el-select>
            </div>
          </div>
          <span class="mt-1">Custom message</span>
          <span class="warning font-class">
            Note: Don't add User fields because there may be multiple users, we only take first user
            details.
          </span>
          <CkEditorOffline
            v-model="editForm.approval_settings.mail_template_data.body"
            :config="editorConfig1"
          ></CkEditorOffline>
          <div
            @click="chooseFromParentEmailTemplates('APPROVER')"
            style="cursor: pointer; color: #409eff; margin-left: 200px"
          >
            <span v-if="!editForm.approval_settings.mail_template_data.name">
              Choose Parent Template(Header & Footer)
            </span>
            <span v-else>Change Parent Template (Header & Footer)</span>
          </div>
          <div
            v-if="editForm.approval_settings.mail_template_data.name"
            class="mb-2"
            style="margin-left: 200px"
          >
            Selected Parent :
            <span>
              {{ editForm.approval_settings.mail_template_data.name }}
            </span>
            <span>
              <i style="cursor: pointer" @click="resetParent" class="el-icon-error"></i>
            </span>
          </div>
          <!--Approval mail template settings-->

          <!--User mail template settings after approvals-->
          <h5 class="mt-1">Notify user after approval settings</h5>
          <el-checkbox v-model="editForm.approval_notify_settings.notify_user">
            Notify after approval?
          </el-checkbox>
          <span v-if="editForm.approval_notify_settings.notify_user">User type</span>
          <el-select
            v-if="editForm.approval_notify_settings.notify_user"
            v-model="editForm.approval_notify_settings.notify_user_type"
            placeholder="Approver type"
            size="mini"
          >
            <el-option value="APPLICATION_USER" label="Application user"></el-option>
            <el-option value="COMPANY_USER" label="Company user"></el-option>
            <el-option value="BASED_ON_DATA" label="Based on data"></el-option>
          </el-select>
          <span
            v-if="
              editForm.approval_notify_settings.notify_user &&
              editForm.approval_notify_settings.notify_user_type !== 'BASED_ON_DATA'
            "
          >
            Type
          </span>
          <el-select
            v-model="editForm.approval_notify_settings.notify_user_ids"
            clearable
            placeholder="Approver users"
            multiple
            size="mini"
            collapse-tags
            v-if="
              editForm.approval_notify_settings.notify_user &&
              editForm.approval_notify_settings.notify_user_type == 'APPLICATION_USER'
            "
          >
            <el-option
              v-for="(entity, i) in (allEntities || []).filter(
                (e) => e.entity_type == 'BUSINESS' || e.entity_type == 'INDIVIDUAL'
              )"
              :key="entity + 'entity' + i"
              :value="entity._id"
              :label="entity.name"
            ></el-option>
          </el-select>
          <el-select
            v-model="editForm.approval_notify_settings.notify_user_ids"
            clearable
            placeholder="Approver users"
            multiple
            size="mini"
            collapse-tags
            v-if="
              editForm.approval_notify_settings.notify_user &&
              editForm.approval_notify_settings.notify_user_type == 'COMPANY_USER'
            "
          >
            <el-option
              v-for="item in getUserTypeList"
              :key="item._id"
              :label="getLabel(item)"
              :value="item._id"
            ></el-option>
          </el-select>
          <span v-if="editForm.approval_notify_settings.notify_user">Users</span>
          <el-select
            v-model="editForm.approval_notify_settings.notify_users"
            clearable
            placeholder="Approver users"
            multiple
            size="mini"
            collapse-tags
            v-if="
              editForm.approval_notify_settings.notify_user &&
              editForm.approval_notify_settings.notify_user_type !== 'BASED_ON_DATA'
            "
          >
            <el-option
              v-for="(user, i) in getUserEmailList(
                editForm.approval_notify_settings.notify_user_ids,
                editForm.approval_notify_settings.notify_user_type
              )"
              :key="user + 'user' + i"
              :value="user.email"
              :label="user.email"
            ></el-option>
          </el-select>
          <el-select
            v-model="editForm.approval_notify_settings.notify_user_fields"
            clearable
            placeholder="Approver user fields"
            multiple
            size="mini"
            collapse-tags
            v-if="
              editForm.approval_notify_settings.notify_user &&
              editForm.approval_notify_settings.notify_user_type == 'BASED_ON_DATA'
            "
          >
            <el-option
              v-for="(field, i) in getUserEntities(
                getFieldsByType(['ENTITY'], allFieldsWithDataTable)
              )"
              :key="field + i"
              :value="field.key"
              :label="field.label"
            ></el-option>
          </el-select>
          <h5 class="mt-1" v-if="editForm.approval_notify_settings.notify_user">
            Email template settings
          </h5>
          <!-- <span v-if="editForm.approval_notify_settings.notify_user"
              >Subject</span
            >-->
          <div v-if="editForm.approval_notify_settings.notify_user" style="display: flex">
            <div style="width: 49%; margin-right: 2%">
              <span>Subject</span>
              <el-input
                v-model="editForm.approval_notify_settings.mail_template_data.subject"
                placeholder="Enter subject"
              ></el-input>
            </div>
            <div style="width: 49%">
              <span>Select Field to copy</span>
              <el-select
                style="width: 100%"
                v-model="copyField"
                placeholder="Select Field to copy"
                filterable
                class="email-field"
                clearable
                @change="copyURL"
              >
                <el-option
                  v-for="(item, index) of getSupportedSubjectFields()"
                  v-bind:key="index"
                  :label="item.label"
                  :value="item.label"
                >
                  {{ item.label }} ({{ item.input_type }})
                  <a
                    v-if="item.isSubjectSupported"
                    @click.stop="pushToSubject(item.label, 'approval_notify_settings')"
                  >
                    <i class="el-icon-right" style="color: #409eff"></i>
                  </a>
                </el-option>
              </el-select>
            </div>
          </div>
          <span class="mt-1" v-if="editForm.approval_notify_settings.notify_user">
            Custom message
          </span>
          <span class="warning font-class" v-if="editForm.approval_notify_settings.notify_user">
            Note: Don't add Approve fields because there may be multiple approvers, we only take
            first approver details.
          </span>
          <CkEditorOffline
            v-if="editForm.approval_notify_settings.notify_user"
            v-model="editForm.approval_notify_settings.mail_template_data.body"
            :config="editorConfig2"
          ></CkEditorOffline>
          <div
            v-if="editForm.approval_notify_settings.notify_user"
            @click="chooseFromParentEmailTemplates('APPROVE_USER')"
            style="cursor: pointer; color: #409eff; margin-left: 200px"
          >
            <span v-if="!editForm.approval_notify_settings.mail_template_data.name">
              Choose Parent Template(Header & Footer)
            </span>
            <span v-else>Change Parent Template (Header & Footer)</span>
          </div>
          <div
            v-if="
              editForm.approval_notify_settings.mail_template_data.name &&
              editForm.approval_notify_settings.notify_user
            "
            class="mb-2"
            style="margin-left: 200px"
          >
            Selected Parent :
            <span>
              {{ editForm.approval_notify_settings.mail_template_data.name }}
            </span>
            <span>
              <i style="cursor: pointer" @click="resetParent" class="el-icon-error"></i>
            </span>
          </div>
          <!--User mail template settings after approvals-->

          <!--User mail template settings after Decline-->
          <h5 class="mt-1">Notify user after decline settings</h5>
          <el-checkbox v-model="editForm.decline_notify_settings.notify_user">
            Notify after decline?
          </el-checkbox>
          <span v-if="editForm.decline_notify_settings.notify_user">User type</span>
          <el-select
            v-if="editForm.decline_notify_settings.notify_user"
            v-model="editForm.decline_notify_settings.notify_user_type"
            placeholder="Approver type"
            size="mini"
          >
            <el-option value="APPLICATION_USER" label="Application user"></el-option>
            <el-option value="COMPANY_USER" label="Company user"></el-option>
            <el-option value="BASED_ON_DATA" label="Based on data"></el-option>
          </el-select>
          <span
            v-if="
              editForm.decline_notify_settings.notify_user &&
              editForm.decline_notify_settings.notify_user_type !== 'BASED_ON_DATA'
            "
          >
            Type
          </span>
          <el-select
            v-model="editForm.decline_notify_settings.notify_user_ids"
            clearable
            placeholder="Approver users"
            multiple
            size="mini"
            collapse-tags
            v-if="
              editForm.decline_notify_settings.notify_user &&
              editForm.decline_notify_settings.notify_user_type == 'APPLICATION_USER'
            "
          >
            <el-option
              v-for="(entity, i) in (allEntities || []).filter(
                (e) => e.entity_type == 'BUSINESS' || e.entity_type == 'INDIVIDUAL'
              )"
              :key="entity + 'entity' + i"
              :value="entity._id"
              :label="entity.name"
            ></el-option>
          </el-select>
          <el-select
            v-model="editForm.decline_notify_settings.notify_user_ids"
            clearable
            placeholder="Approver users"
            multiple
            size="mini"
            collapse-tags
            v-if="
              editForm.decline_notify_settings.notify_user &&
              editForm.decline_notify_settings.notify_user_type == 'COMPANY_USER'
            "
          >
            <el-option
              v-for="item in getUserTypeList"
              :key="item._id"
              :label="getLabel(item)"
              :value="item._id"
            ></el-option>
          </el-select>
          <span v-if="editForm.decline_notify_settings.notify_user">Users</span>
          <el-select
            v-model="editForm.decline_notify_settings.notify_users"
            clearable
            placeholder="Approver users"
            multiple
            size="mini"
            collapse-tags
            v-if="
              editForm.decline_notify_settings.notify_user &&
              editForm.decline_notify_settings.notify_user_type !== 'BASED_ON_DATA'
            "
          >
            <el-option
              v-for="(user, i) in getUserEmailList(
                editForm.decline_notify_settings.notify_user_ids,
                editForm.decline_notify_settings.notify_user_type
              )"
              :key="user + 'user' + i"
              :value="user.email"
              :label="user.email"
            ></el-option>
          </el-select>
          <el-select
            v-model="editForm.decline_notify_settings.notify_user_fields"
            clearable
            placeholder="Approver user fields"
            multiple
            size="mini"
            collapse-tags
            v-if="
              editForm.decline_notify_settings.notify_user &&
              editForm.decline_notify_settings.notify_user_type == 'BASED_ON_DATA'
            "
          >
            <el-option
              v-for="(field, i) in getUserEntities(
                getFieldsByType(['ENTITY'], allFieldsWithDataTable)
              )"
              :key="field + i"
              :value="field.key"
              :label="field.label"
            ></el-option>
          </el-select>
          <h5 class="mt-1" v-if="editForm.decline_notify_settings.notify_user">
            Email template settings
          </h5>
          <div v-if="editForm.decline_notify_settings.notify_user" style="display: flex">
            <div style="width: 49%; margin-right: 2%">
              <span>Subject</span>
              <el-input
                v-model="editForm.decline_notify_settings.mail_template_data.subject"
                placeholder="Enter subject"
              ></el-input>
            </div>
            <div style="width: 49%">
              <span>Select Field to copy</span>
              <el-select
                style="width: 100%"
                v-model="copyField"
                placeholder="Select Field to copy"
                filterable
                class="email-field"
                clearable
                @change="copyURL"
              >
                <el-option
                  v-for="(item, index) of getSupportedSubjectFields()"
                  v-bind:key="index"
                  :label="item.label"
                  :value="item.label"
                >
                  {{ item.label }} ({{ item.input_type }})
                  <a
                    v-if="item.isSubjectSupported"
                    @click.stop="pushToSubject(item.label, 'decline_notify_settings')"
                  >
                    <i class="el-icon-right" style="color: #409eff"></i>
                  </a>
                </el-option>
              </el-select>
            </div>
          </div>
          <span class="mt-1" v-if="editForm.decline_notify_settings.notify_user">
            Custom message
          </span>
          <span class="warning font-class" v-if="editForm.decline_notify_settings.notify_user">
            Note: Don't add Approve fields because there may be multiple approvers, we only take
            first approver details.
          </span>
          <CkEditorOffline
            v-if="editForm.decline_notify_settings.notify_user"
            v-model="editForm.decline_notify_settings.mail_template_data.body"
            :config="editorConfig3"
          ></CkEditorOffline>
          <div
            v-if="editForm.decline_notify_settings.notify_user"
            @click="chooseFromParentEmailTemplates('DECLINE_USER')"
            style="cursor: pointer; color: #409eff; margin-left: 200px"
          >
            <span v-if="!editForm.decline_notify_settings.mail_template_data.name">
              Choose Parent Template(Header & Footer)
            </span>
            <span v-else>Change Parent Template (Header & Footer)</span>
          </div>
          <div
            v-if="
              editForm.decline_notify_settings.mail_template_data.name &&
              editForm.decline_notify_settings.notify_user
            "
            class="mb-2"
            style="margin-left: 200px"
          >
            Selected Parent :
            <span>
              {{ editForm.decline_notify_settings.mail_template_data.name }}
            </span>
            <span>
              <i style="cursor: pointer" @click="resetParent" class="el-icon-error"></i>
            </span>
          </div>
          <!--User mail template settings after decline-->
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="resetEditModal">Close</el-button>
        <el-button
          type="primary"
          :disabled="checkLockFolderDisabled(editForm)"
          @click="update"
          :loading="loading"
        >
          Save
        </el-button>
      </span>
    </dialog-component>
  </div>
</template>

<script>
  import { fetchAllFiles } from '../actionHelper';
  import { mapGetters } from 'vuex';
  import commonHelper from './commonHelper';
  import templateBuilderHelper from '../../../../mixins/templateBuilderHelper';
  import StepEditableMixin from './StepEditableMixin';
  import { mapMailTemplateVariables } from '../actionHelper';
  export default {
    name: 'AddFolderAction',
    props: {
      step: Object,
      entity_id: String,
      trigger: Object,
      currentEntity: Object,
      allEntities: Array,
      allEntityFilters: Object,
      allContacts: Array,
      companyUsers: Array,
    },
    mixins: [StepEditableMixin, templateBuilderHelper, commonHelper],
    data() {
      return {
        openNewFileModal: false,
        deleteFolder: false,
        editForm: {},
        editFormIndex: -1,
        settingsModal: false,
        mapFolderConfigureModal: false,
        actionEntityFoldersList: [],
        actionEntityFoldersListFolder: '',
        actionEntityFoldersListType: 'ROOT',
        deleteActionEntityFoldersList: {
          type: 'ROOT',
          query_on: 'CREATED',
          query_type: 'YEAR',
          query_duration: 1,
          folder: '',
        },
        newFile: {
          name: '',
          type: 'FOLDER',
          path: '',
          file: null,
          file_format: '',
          files: [],
          entityRelationships: [],
          sharedList: [],
          name_mapped_with: '',
          permission_settings: {
            type: 'DAY',
            value: 1,
            application_users: [],
            lock_folder: false,
          },
          approval_settings: {
            approval_folder: false,
            requesting_users: [],
            approver_type: 'APPLICATION_USER',
            approver_user_ids: [],
            approver_users: [],
            mail_template_data: {
              subject: 'Approval request',
              body: '<p>Hello,</p>\n\n<p>Please click on the below link to approve it.</p>\n\n<p>Thank you.</p>\n',
              cc_user: [],
              header_body: '',
              footer_body: '',
              name: '',
            },
          },
          approval_notify_settings: {
            notify_user_type: 'APPLICATION_USER',
            notify_user_ids: [],
            showDelete: '',
            notify_users: [],
            notify_user_fields: [],
            notify_user: false,
            mail_template_data: {
              subject: 'Files has approved',
              body: '<p>Hello,</p>\n\n<p>Please click on the below link to view files.</p>\n\n<p>Thank you.</p>\n',
              cc_user: [],
              header_body: '',
              footer_body: '',
              name: '',
            },
          },
          decline_notify_settings: {
            notify_user_type: 'APPLICATION_USER',
            notify_user_ids: [],
            showDelete: '',
            notify_users: [],
            notify_user_fields: [],
            notify_user: false,
            mail_template_data: {
              subject: 'Files has declined',
              body: '<p>Hello,</p>\n\n<p>We are regret to inform you that your File has been rejected.</p>\n\n<p>Thank you.</p>\n',
              cc_user: [],
              header_body: '',
              footer_body: '',
              name: '',
            },
          },
        },
        entityRootFolders: [],
      };
    },
    async mounted() {
      await this.initiateData();
    },
    computed: {
      ...mapGetters('auth', ['getUserTypeList']),
      checkDisabled() {
        if (this.newFile.type) {
          if (this.newFile.type == 'FILE') {
            return !this.newFile.files || !this.newFile.files.length;
          }
          return !this.newFile.name && !this.newFile.name_mapped_with
            ? true
            : this.checkLockFolderDisabled(this.newFile);
        }
        return true;
      },
    },
    methods: {
      openFolderConfigureModal() {
        this.deleteFolder = false;
        this.mapFolderConfigureModal = true;
        this.actionEntityFoldersList = this.localStep.folders_list || [];
        this.actionEntityFoldersListFolder = this.localStep.create_on_folder || '';
        this.actionEntityFoldersListType = this.trigger.is_global_action ? 'ROOT' : 'CURRENT_DATA';
      },
      resetFolderConfigureTemplate() {
        if (this.deleteFolder) {
          this.$set(this.localStep, 'delete_folders_list', this.deleteActionEntityFoldersList);
        } else {
          this.$set(this.localStep, 'folders_list', this.actionEntityFoldersList);
          this.$set(this.localStep, 'create_on_folder', this.actionEntityFoldersListFolder);
          this.$set(this.localStep, 'folder_type', this.actionEntityFoldersListType);
        }
        this.actionEntityFoldersList = [];
        this.actionEntityFoldersListFolder = '';
        this.actionEntityFoldersListType = this.trigger.is_global_action ? 'ROOT' : 'CURRENT_DATA';
        this.deleteActionEntityFoldersList = {
          type: 'ROOT',
          query_on: 'CREATED',
          query_type: 'YEAR',
          query_duration: 1,
        };
        this.deleteFolder = false;
        this.mapFolderConfigureModal = false;
      },
      openNew() {
        this.openNewFileModal = true;
      },
      async initiateData() {
        this.entityRootFolders = await fetchAllFiles({
          entity_id: this.entity_id,
        });
        this.allFieldsWithDataTable = this.getAllFieldsFromEntity(
          this.currentEntity,
          true,
          true,
          true
        );
      },
      checkSelfTriggerAction() {
        return this.trigger?.when == 'ADDED' || this.trigger?.when.includes('template/');
      },
      saveFolder() {
        this.actionEntityFoldersList.push(JSON.parse(JSON.stringify(this.newFile)));
        this.resetModal();
      },
      resetModal() {
        this.openNewFileModal = false;
        this.newFile.path = '';
        this.newFile.file = '';
        this.newFile.name = '';
        this.newFile.file_format = '';
        this.newFile.entityRelationships = [];
        this.newFile.sharedList = [];
        this.newFile.name_mapped_with = '';
        this.newFile.type = 'FOLDER';
      },
      checkLockFolderDisabled(newFile) {
        if (
          newFile?.permission_settings?.lock_folder &&
          !newFile?.approval_settings?.approval_folder
        ) {
          return (
            !newFile?.permission_settings?.type ||
            !newFile?.permission_settings?.application_users.length ||
            typeof this.newFile?.permission_settings?.value !== 'number'
          );
        }
        if (newFile?.approval_settings?.approval_folder) {
          return (
            !newFile?.approval_settings?.requesting_users.length ||
            !newFile?.approval_settings?.approver_type ||
            !newFile?.approval_settings?.approver_user_ids.length ||
            (newFile?.approval_notify_settings?.notify_user &&
              (!newFile?.approval_notify_settings?.notify_user_type ||
                (!newFile?.approval_notify_settings?.notify_user_ids.length &&
                  !newFile?.approval_notify_settings?.notify_users.length &&
                  !newFile?.approval_notify_settings?.notify_user_fields.length) ||
                !newFile?.approval_notify_settings?.mail_template_data?.subject ||
                !newFile?.approval_notify_settings?.mail_template_data?.body))
          );
        }
        return false;
      },
      resetEditModal() {
        this.editForm = {};
        this.editFormIndex = -1;
        this.settingsModal = false;
      },
      openSettingsModal(file, i) {
        this.editForm = JSON.parse(JSON.stringify({ ...file }));
        if (!this.editForm.permission_settings) {
          this.editForm = JSON.parse(
            JSON.stringify({
              ...this.editForm,
              ...{
                permission_settings: {
                  type: 'DAY',
                  value: 1,
                  application_users: [],
                  lock_folder: false,
                },
              },
            })
          );
        }
        if (!this.editForm.approval_settings) {
          this.editForm = JSON.parse(
            JSON.stringify({
              ...this.editForm,
              ...{
                approval_settings: {
                  approval_folder: false,
                  requesting_users: [],
                  approver_type: 'APPLICATION_USER',
                  approver_user_ids: [],
                  approver_users: [],
                  mail_template_data: {
                    subject: 'Approval request',
                    body: '<p>Hello,</p>\n\n<p>Please click on the below link to approve it.</p>\n\n<p>Thank you.</p>\n',
                    cc_user: [],
                    header_body: '',
                    footer_body: '',
                    name: '',
                  },
                },
              },
            })
          );
        } else {
          if (!this.editForm?.approval_settings?.mail_template_data) {
            this.editForm['approval_settings'] = JSON.parse(
              JSON.stringify({
                ...this.editForm['approval_settings'],
                mail_template_data: {
                  subject: 'Approval request',
                  body: '<p>Hello,</p>\n\n<p>Please click on the below link to approve it.</p>\n\n<p>Thank you.</p>\n',
                  cc_user: [],
                  header_body: '',
                  footer_body: '',
                  name: '',
                },
              })
            );
          } else {
            if (this.editForm?.approval_settings?.mail_template_data?.body) {
              this.editForm.approval_settings.mail_template_data.body = mapMailTemplateVariables(
                this.editForm.approval_settings.mail_template_data.body,
                true
              );
            }
            if (this.editForm?.approval_settings?.mail_template_data?.subject) {
              this.editForm.approval_settings.mail_template_data.subject = mapMailTemplateVariables(
                this.editForm.approval_settings.mail_template_data.subject,
                true
              );
            }
          }
        }
        if (!this.editForm.approval_notify_settings) {
          this.editForm = JSON.parse(
            JSON.stringify({
              ...this.editForm,
              ...{
                approval_notify_settings: {
                  notify_user_type: 'APPLICATION_USER',
                  notify_user_ids: [],
                  notify_users: [],
                  notify_user_fields: [],
                  mail_template_data: {
                    subject: 'Files has approved',
                    body: '<p>Hello,</p>\n\n<p>Please click on the below link to approve it.</p>\n\n<p>Thank you.</p>\n',
                    cc_user: [],
                    header_body: '',
                    footer_body: '',
                    name: '',
                  },
                },
              },
            })
          );
        } else {
          if (this.editForm?.approval_notify_settings?.mail_template_data?.body) {
            this.editForm.approval_notify_settings.mail_template_data.body =
              mapMailTemplateVariables(
                this.editForm.approval_notify_settings.mail_template_data.body,
                true
              );
          }
          if (this.editForm?.approval_notify_settings?.mail_template_data?.subject) {
            this.editForm.approval_notify_settings.mail_template_data.subject =
              mapMailTemplateVariables(
                this.editForm.approval_notify_settings.mail_template_data.subject,
                true
              );
          }
        }

        if (!this.editForm.decline_notify_settings) {
          this.editForm = JSON.parse(
            JSON.stringify({
              ...this.editForm,
              ...{
                decline_notify_settings: {
                  notify_user_type: 'APPLICATION_USER',
                  notify_user_ids: [],
                  notify_users: [],
                  notify_user_fields: [],
                  mail_template_data: {
                    subject: 'Files has declined',
                    body: '<p>Hello,</p>\n\n<p>We are regret to inform you that your File has been rejected.</p>\n\n<p>Thank you.</p>\n',
                    cc_user: [],
                    header_body: '',
                    footer_body: '',
                    name: '',
                  },
                },
              },
            })
          );
        } else {
          if (this.editForm?.decline_notify_settings?.mail_template_data?.body) {
            this.editForm.decline_notify_settings.mail_template_data.body =
              mapMailTemplateVariables(
                this.editForm.decline_notify_settings.mail_template_data.body,
                true
              );
          }
          if (this.editForm?.decline_notify_settings?.mail_template_data?.subject) {
            this.editForm.decline_notify_settings.mail_template_data.subject =
              mapMailTemplateVariables(
                this.editForm.decline_notify_settings.mail_template_data.subject,
                true
              );
          }
        }
        if (!this.editForm.upload_filter) {
          this.editForm['upload_filter'] = '';
        }

        this.editFormIndex = i;
        this.settingsModal = true;
      },
    },
  };
</script>
<style>
  .action-config-item {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .popUp-content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem 0;
  }

  .delete-files-container {
    font-weight: 500;
    font-size: 14px;
  }

  .files-container {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    margin-top: 1rem;
  }

  .single-file {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 90px;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    padding: 0.5rem;
  }

  .single-file:hover {
    background: #f5f7fa;
    border-color: #dcdfe6;
  }

  .file-header {
    font-size: 24px;
    display: flex;
    justify-content: center;
    margin-bottom: 0.25rem;
  }

  .file-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    font-size: 13px;
    text-align: center;
  }

  .file-title span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
  }

  .file-title .action-button {
    display: flex;
    justify-content: flex-end;
    margin-left: 0.5rem;
  }

  .no-files {
    display: flex;
    justify-content: center;
    padding: 2rem 0;
  }

  .upload-attchment-box {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px dashed #dcdfe6;
    border-radius: 6px;
    padding: 0.75rem;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .upload-attchment-box:hover {
    border-color: #409eff;
    background: #f0f7ff;
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
  }

  /* Utility spacing classes */
  .mt-1 {
    margin-top: 0.5rem;
  }
  .mb-1 {
    margin-bottom: 0.5rem;
  }
  .ml-1 {
    margin-left: 0.5rem;
  }
  .mr-1 {
    margin-right: 0.5rem;
  }

  .d-flex {
    display: flex;
  }

  .flex-wrap {
    flex-wrap: wrap;
  }

  .align-center {
    align-items: center;
  }

  .gap-1 {
    gap: 0.5rem;
  }

  .m-tb-2 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .m-lr-2 {
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .font-class {
    font-size: 12px;
    color: #909399;
  }

  .warning {
    display: block;
    margin-top: 4px;
  }
</style>
